export default "__VITE_ASSET__Bub0fof$__"